import React, { ReactNode } from 'react';

import { ChevronRight } from '@mui/icons-material';
import { Paper, Typography, SxProps } from '@mui/material';

import { Row } from '../atoms/row';
import { colors } from '../theme/palette';
import { To, useNavigate } from 'react-router-dom';

type ItemProps = {
  label: ReactNode;
  icon: ReactNode;
  to?: To;
};

export const NavigationItem = ({ label, icon, to }: ItemProps) => {
  const navigate = useNavigate();

  return (
    <Paper
      sx={{
        '& svg:first-child': { fontSize: '1.5rem', color: 'primary.main' },
        '& svg:last-child': { fontSize: '0.85rem', color: 'text.main' },
        cursor: to ? 'pointer' : 'default',
      }}
      onClick={
        to
          ? () => {
              navigate(to);
            }
          : undefined
      }
    >
      <Row>
        {icon}

        <Typography variant="h3" sx={{ display: 'inline', ml: 1, mr: 'auto' }}>
          {label}
        </Typography>

        <ChevronRight />
      </Row>
    </Paper>
  );
};

export const NavigationList = ({
  children,
  sx,
}: {
  children?: ReactNode;
  sx?: SxProps;
}) => {
  return (
    <Paper
      sx={{
        p: 0,
        '& .MuiPaper-root': {
          boxShadow: 0,
          '&:not(:last-child)': {
            pb: 0,
          },
          '&:not(:last-child):after': {
            content: '""',
            display: 'block',
            borderBottomStyle: 'solid',
            borderBottomWidth: { xs: 0.25, md: 1 },
            borderBottomColor: colors.darkBlue,
            opacity: { xs: 0.4, md: 0.2 },
            mt: 1.5,
            mb: 0,
          },
        },
        ...(sx ?? {}),
      }}
    >
      {children}
    </Paper>
  );
};
